import React from "react";
import InputRequire from "views/components/InputRequire";

const InstitutionNameField = ({ name, onChange, error, t }) => (
  <div className="form-group">
    <div
      className={
        error?.length
          ? "col-lg-9 col-md-9 col-sm-12 m-auto validated"
          : "col-lg-9 col-md-9 col-sm-12 m-auto"
      }
    >
      <label htmlFor="name">
        {t("Nom de l'institution")} <InputRequire />
      </label>
      <input
        disabled={true}
        id="name"
        type="text"
        className={error?.length ? "form-control is-invalid" : "form-control"}
        placeholder="Veuillez entrer le nom de l'institution"
        value={name}
        onChange={onChange}
      />
      {error?.length &&
        error.map((err, index) => (
          <div key={index} className="invalid-feedback">
            {err}
          </div>
        ))}
    </div>
  </div>
);

export default InstitutionNameField;
